export const IconNameSeparator = '-'
